import {Navigate} from "react-router-dom";

export default function CheckEnvironment({children, redirectTo}) {

    const production = process.env.NODE_ENV === "production";
    console.log(production)

    return production ? <Navigate to={redirectTo}/> : children
}